export const ImageGallerySkeleton = () => {
    return (
        <div className="flex justify-content-center align-items-center image-gallery-skeleton">
            <span className="pi pi-spin pi-spinner image-gallery-skeleton-spinner" />
        </div>
    );
};
